import { PayMethodEventDetailProductType } from '../../../lib/api/payMethodExhibit';

/** DB 에는 영문으로 저장하고 화면에는 한글만 노출한다. */
export const PRODUCT_TYPE_LABEL: Record<PayMethodEventDetailProductType, string> = {
  all: '전체',
  normal: '일반·포인트',
  gold: '24K 골드',
};

/**
 * 결제수단별로 쓸 수 있는 상품 유형.
 *
 * 간편결제는 상품 유형을 따지지 않고(`all`), 카드·계좌이체·가상계좌는 유형별로 갈린다.
 * 🔴 user-api `PaymentManager.getPayMethodEventDetails` 의 분기와 같아야 한다 —
 * 여기서 허용하지 않는 조합을 넣으면 저장은 되지만 고객 화면에 절대 나오지 않는다.
 */
const EASY_PAY_METHOD_TYPES = ['kakaopay', 'naverpay', 'payco', 'tosspay'];

export const getAvailableProductTypes = (payMethodType: string): PayMethodEventDetailProductType[] =>
  EASY_PAY_METHOD_TYPES.includes(payMethodType) ? ['all'] : ['normal', 'gold'];
